// LWI-1549 — one location shape for the wizard store.
//
// Three shapes are in play:
//   - the API (GetMSRByNumber): locationCode, name, address1, address2, city,
//     state, country, postalCode, phone, email, openHours, closedHours
//   - LocationCard.onChange:    locationCode, name, address1, address2, city,
//     state, zip, country, open, close, contactName, contactPhone, contactEmail
//   - LocationCard display:     postalCode, openHours, closedHours, contactName,
//     contactPhone, contactEmail, location_code (title chip)
// The store keeps the union so LocationCard can both display and edit, and the
// backend mapping (MsrHeaderPayload) accepts either spelling.

const pick = (obj, keys) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return "";
};

/**
 * A `GET location/{code}` record (mysql.location row) → the store shape.
 * Same field mapping the classic Create page used for the profile default
 * Ship From (LWI-1143 / LWI-1312 contacts).
 */
export const locationFromApiRecord = (loc, fallbackCode = "") => {
  if (!loc || typeof loc !== "object") return null;
  const hhmm = (t) => (t ? String(t).slice(0, 5) : "");
  return normalizeLocation({
    locationCode: loc.location_id || fallbackCode,
    name: loc.location_name || "",
    address1: loc.address_1 || "",
    address2: loc.address_2 || "",
    city: loc.city || "",
    state: loc.state_province || "",
    zip: loc.postal_code || "",
    country: loc.country || "",
    open: hhmm(loc.open_time),
    close: hhmm(loc.close_time),
    contactName: loc.contact_name || "",
    contactPhone: loc.contact_phone || "",
    contactEmail: loc.contact_email || "",
  });
};

export const normalizeLocation = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  const locationCode = pick(raw, ["locationCode", "location_code"]);
  const postalCode = pick(raw, ["postalCode", "zip"]);
  const phone = pick(raw, ["phone", "contactPhone", "contact_phone"]);
  const email = pick(raw, ["email", "contactEmail", "contact_email"]);
  const openHours = pick(raw, ["openHours", "open"]);
  const closedHours = pick(raw, ["closedHours", "closeHours", "close"]);
  const contactName = pick(raw, ["contactName", "contact", "contact_name"]);
  return {
    locationCode,
    location_code: locationCode,
    name: pick(raw, ["name"]),
    address1: pick(raw, ["address1", "address_1", "address"]),
    address2: pick(raw, ["address2", "address_2"]),
    city: pick(raw, ["city"]),
    state: pick(raw, ["state", "state_province"]),
    country: pick(raw, ["country"]),
    postalCode,
    zip: postalCode,
    phone,
    email,
    openHours,
    closedHours,
    contactName,
    contactPhone: phone,
    contactEmail: email,
  };
};

/** True when a location has at least a code or a name. */
export const hasLocation = (loc) =>
  !!loc &&
  (String(loc.locationCode || "").trim() !== "" ||
    String(loc.name || "").trim() !== "");

/** The API-shaped block to PUT (MsrHeaderPayload maps postalCode/phone/email/openHours/closedHours/contactName). */
export const locationToApi = (loc) => {
  if (!loc) return null;
  return {
    locationCode: loc.locationCode ?? "",
    name: loc.name ?? "",
    address1: loc.address1 ?? "",
    address2: loc.address2 ?? "",
    city: loc.city ?? "",
    state: loc.state ?? "",
    country: loc.country ?? "",
    postalCode: loc.postalCode ?? "",
    phone: loc.phone ?? "",
    email: loc.email ?? "",
    openHours: loc.openHours ?? "",
    closedHours: loc.closedHours ?? "",
    contactName: loc.contactName ?? "",
  };
};
